import { Tour } from "nextstepjs";
export function getDeviceSpecificSide() {
  if (typeof window === "undefined") return "top";

  const width = window.innerWidth;
  const userAgent = navigator.userAgent.toLowerCase();
  const isIPhone = /iphone/.test(userAgent);
  const isAndroid = /android/.test(userAgent);
  // Range-based logic
  if (isIPhone) {
    if (width <= 360) return "top-left"; // iPhone SE, older small phones
    if (width <= 400) return "top-right"; // iPhone 12, Mini, etc.
    if (width <= 450) return "top"; // iPhone 14, Pro Max, etc.
  } else if (isAndroid) {
    if (width <= 415) return "top-right"; // Pixel 6/7/8
    if (width <= 360) return "top-left"; // Small Android phones
    if (width <= 430) return "top-right"; // Mid Android devices
  }
  // Fallback
  return "top";
}

const specificSide = getDeviceSpecificSide();

const productGuide: Tour[] = [
  {
    tour: "productTour",
    steps: [
      {
        icon: null,
        title: "",
        content: "Click the heart icon to add a product to your favorites.",
        selector: "#favorite_button",
        side: specificSide,
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: null,
        title: "",
        content: "To add a product to your shopping list, click here!",
        selector: "#add_to_cart_product",
        side: specificSide,
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
    ],
  },
];

export default productGuide;
